import { Box, ColorOptions, IconButton, ModBox, Spacer, Text } from '@jfs/ui-new'
import { StatusIndicator } from '../../../../../components/StatusIndicator'

const Header = ({
  from,
  navigation,
  setSideMenuRefresh,
  applicationId,
  headerData,
  handleBackFromParent,
  status,
}: any) => {
  const handleBack = () => {
    if (from === 'AD_CHECKER') {
      navigation.navigate('aadharCheckerQueue')
      setSideMenuRefresh(true)
    } else if (from === 'AD_MAKER') {
      navigation.navigate('aadharMakerQueue')
      setSideMenuRefresh(true)
    } else if (handleBackFromParent) {
      handleBackFromParent()
    } else {
      navigation.goBack()
      setSideMenuRefresh(true)
    }
  }
  return (
    <ModBox borderBottomWidth={1} borderBottomColor={'BORDER_COLOR'}>
      <Box p={16}>
        <ModBox direction="row" justifyContent={'space-between'}>
          <ModBox>
            <ModBox direction="row" h={24} alignItems={'center'}>
              <IconButton id="ARROW_BACK" size={24} color={'#0070B6' as ColorOptions} onPress={handleBack} />
              <Text title={'Aadhaar Redaction'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
              <Spacer size={16} direction="horizontal" />
              <StatusIndicator type={status?.toLowerCase()} />
            </ModBox>
            <ModBox
              w={'100%'}
              direction="row"
              marginLeft={32}
              marginRight={16}
              justifyContent={'space-between'}
              marginTop={8}>
              <ModBox direction="row" flexWrap={'wrap'} w={'100%'}>
                <Box
                  backgroundColor={'#F0F0F0' as ColorOptions}
                  borderRadius={2}
                  padding={4}
                  direction={'row'}
                  marginRight={24}>
                  <Text title={'ID: '} color={'BLACK_75'} fontSize={12} fontFamily={'jiotype-medium'} />
                  <Text title={applicationId} color={'BLACK_21'} fontSize={12} fontFamily={'jiotype-bold'} />
                </Box>
              </ModBox>
            </ModBox>
          </ModBox>
        </ModBox>
      </Box>
    </ModBox>
  )
}

export { Header }
